import React from 'react'

function Profile() {
  return (
    <div className='text-white'>Profile</div>
  )
}

export default Profile